import { FC, useState } from "react";
import VilleInput, { Destination } from "../VilleInput";
import GuestsInput from "../GuestsInput";
import StayDatesRangeInput from "./StayDatesRangeInput";

export interface VoyageSedentaireSearchFormProps {
  onChangeLoading: () => void;
}

const VoyageSedentaireSearchForm: FC<VoyageSedentaireSearchFormProps> = ({onChangeLoading}) => {
 
  const [selectedDestinations, setSelectedDestinations] = useState<Destination[]>([]);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [bookingChecked, setBookingChecked] = useState<boolean>(true);

  const handleSelectDestination = (codePays: string, pays: string, ville: string, place_id: string, latitude: string, longitude: string) => {
    const selectedDestination: Destination = {
      code_pays: codePays,
      pays: pays,
      ville: ville,
      place_id: place_id,
      latitude: latitude,
      longitude: longitude,
    };
  
    setSelectedDestinations([selectedDestination]);
    
  };

  const handleSelectDates = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

  };

  const handleChangeLoading = () => {
    onChangeLoading();
  };

  const handleCheckboxChange = (value: boolean) => {
    setBookingChecked(value);
  }

  const renderForm = () => {
    return (
      <>
      <form className="w-full relative mt-3 flex rounded-full shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-800 ">
        <VilleInput className="flex-[1.5]"  onSelectDestination={handleSelectDestination}/>
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <StayDatesRangeInput className="flex-1" onSelectDates={handleSelectDates}/>
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <GuestsInput className="flex-1" selectedDestinations={selectedDestinations}  startDate={startDate} endDate={endDate} onChangeLoading={handleChangeLoading} checkboxBooking={bookingChecked}/>
      </form>
        {/*  <p className="text-right mt-4 mr-10 text-xs text-neutral-500">Rechercher un hébergement sur Booking.com  <input
        id="checkboxBooking"
        name="checkboxBooking"
        type="checkbox"
        className="focus:ring-action-primary h-3 w-3 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
        checked={bookingChecked}
        onChange={(e) => handleCheckboxChange(e.target.checked)}
      /></p>*/}
      </>
    );
  };

  return renderForm();
};

export default VoyageSedentaireSearchForm;
